import {api} from './api';

interface ApiResponse<T> {
    code: string;
    success: boolean;
    message: string;
    data: T;
}

export interface AssessmentStatusResponse {
    completed: boolean;
    currentStep: number;
}

export interface AssessmentRequest {
    question1Reason: number;
    question2RiskLevel: number;
    question3Amount: number;
}

export const assessmentService = {
    /**
     * 获取测评状态
     */
    getAssessmentStatus: async (userId: number): Promise<AssessmentStatusResponse> => {
        const response = await api.get<ApiResponse<AssessmentStatusResponse>>(
            `/api/v1/users/assessment/status?userId=${userId}`
        );
        if (!response.data.success) {
            throw new Error(response.data.message || '获取测评状态失败');
        }
        return response.data.data!;
    },

    /**
     * 提交测评答案
     */
    submitAssessment: async (userId: number, request: AssessmentRequest): Promise<void> => {
        const response = await api.post<ApiResponse<null>>(
            `/api/v1/users/assessment/submit?userId=${userId}`,
            request
        );
        if (!response.data.success) {
            throw new Error(response.data.message || '提交测评失败');
        }
    },
};
